<svg
  width="201"
  height="196"
  viewBox="0 0 201 196"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
>
  <path
    d="M61.4387 8.56781C58.9311 53.9472 54.7871 99.4168 57.2491 144.902C58.0774 160.205 62.1432 177.372 61.3092 192.465"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M134.631 6.14453C134.631 53.1918 133.246 100.4 136.325 147.358C137.336 162.774 141.409 179.179 141.409 194.241"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M1.51172 71.3173C42.1184 71.3173 82.725 71.3173 123.332 71.3173C147.24 71.3173 170.932 67.9282 194.691 67.9282"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M4.02344 134.017C47.4817 134.017 94.0203 130.406 137.361 134.017C142.267 134.426 199.105 131.352 199.105 131.352"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M57.4597 192.252L59.8984 8.48242"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M141.226 193.951L133.508 1"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M195.333 70.3355L1 70.3356"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M197.918 134.652L3.58594 134.652"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
